import React from 'react';
import { FileDownloader, Tooltip } from 'components';
import { format } from 'date-fns';
import { es, enUS } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

interface PatientDataTableProps {
	className?: string;
	data: any;
}

export const PatientDataTable = ({
	className,
	data,
}: PatientDataTableProps) => {
	const { t, i18n } = useTranslation();
	const keys = Array.from(Object.keys(data));

	const DrugsInfo = ({ drugs }: { drugs: Array<any> }) => {
		return (
			<table className='striped w-full table-fixed text-left'>
				<tbody>
					{drugs.map((drug, i) => {
						let dt = new Date(drug.lastAplicationDate);
						const dtDateOnly = new Date(
							dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000
						);
						return (
							<tr
								key={drug.createdAt}
								className={i + 1 !== drugs.length ? 'border-b' : ''}
							>
								<tr>
									<td className='font-medium'>{`${t('name')}`}</td>
									<td>{drug.name}</td>
								</tr>
								<tr>
									<td className='font-medium'>{`${t('dose')}`}</td>
									<td>{drug.dose}</td>
								</tr>
								{drug.lastAplicationDate && (
									<tr>
										<td className='font-medium'>{t('lastApplicationDate')}</td>
										<td>
											{format(new Date(dtDateOnly), 'EEEE d MMMM, yyyy', {
												locale: i18n.language === 'es' ? es : enUS,
											})}
										</td>
									</tr>
								)}
							</tr>
						);
					})}
				</tbody>
			</table>
		);
	};

	return (
		<table
			className={cn(
				'patient-table striped w-full table-fixed text-left',
				className
			)}
		>
			<tbody>
				{keys.map((k, i) => {
					let type = typeof data[k];
					let value = data[k];

					if (k === 'createdAt' || k.includes('Date')) {
						let dt = new Date(data[k]);
						const dtDateOnly = new Date(
							dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000
						);

						value = format(new Date(dtDateOnly), 'dd/MM/yyyy', {
							locale: i18n.language === 'es' ? es : enUS,
						});
					}

					if (
						(k.includes('consentDate') && !data.consent) ||
						(k.includes('relapseDate') && !data.relapse)
					) {
						return null;
					}
					return (
						<tr key={i}>
							{data[k] && (
								<>
									<td className='w-[35%] font-medium'>
										<div className='flex items-center'>
											{t(k)}
										</div>
									</td>
									<td className='break-words'>
										{type !== 'object' ? (
											type === 'boolean' ? (
												value ? (
													t('yes')
												) : (
													t('no')
												)
											) : (
												value
											)
										) : k.includes('Date') ? (
											format(new Date(data[k]), 'dd/MM/yyyy', {
												locale: i18n.language === 'es' ? es : enUS,
											})
										) : value instanceof Array ? (
											<DrugsInfo drugs={value} />
										) : (
											value !== null && <FileDownloader file={value} />
										)}
									</td>
								</>
							)}
						</tr>
					);
				})}
			</tbody>
		</table>
	);
};
